import { createContext, useContext, useRef, useState } from "react";
import { ConfirmDialog } from "./ConfirmDialog";

const ConfirmServiceContext = createContext(Promise.reject);

export const useConfirm = () => useContext(ConfirmServiceContext);

export const ConfirmServiceProvider = ({ children }) => {
  const [confirmationState, setConfirmationState] = useState(null);

  const awaitingPromiseRef = useRef();

  const openConfirmation = (options) => {
    setConfirmationState(options);
    return new Promise((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = (res) => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve(res);
    }

    setConfirmationState(null);
  };

  return (
    <>
      <ConfirmServiceContext.Provider
        value={openConfirmation}
        children={children}
      />

      <ConfirmDialog
        open={Boolean(confirmationState)}
        onClose={handleClose}
        {...confirmationState}
      />
    </>
  );
};
